import React from 'react';

const Title = () => (
  <div className="breakdown-logo">
    <img src="breakdown-logo.png" alt="logo" />
    <h1>
      <span className="break">Break</span>
      {' '}<span className="down">down</span>
    </h1>
  </div>
  );

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title.js